import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteRate, deleteRateCategory, getRateByResortId, getRateCategoryByResortIdResorCategoryId } from "../../../../../../../apis/property";

import CreateRate from "./createRate";
import EditRate from "./editRate";
const Rate = () => {
  const { id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [rateCategory, setRateCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedRateId, setSelectedRateId] = useState(null);
  const [rate, setRate] = useState({});

  const fetchRateCategory = async (rateClassId) => {
    try {
      const response = await getRateCategoryByResortIdResorCategoryId(rateClassId);
      console.log(response)
      return response.data.name;
    } catch (error) {
      console.log('Error fetching rate class');
      return '';
    }
  };

  const fetchRate= async () => {
    try {
      const response = await getRateByResortId(id);
      const rates = response.data.rates;
      // Fetch room class names
      const rateCategoryPromises = rates.map(async (rate) => {
        const rateCategory = await fetchRateCategory(rate.rate_category_id);
        return { id: rate.id, rateCategory };
      });

      const rateCategorysResults = await Promise.all(rateCategoryPromises);
      const rateCategorysMap = rateCategorysResults.reduce((acc, { id, rateCategory }) => {
        acc[id] = rateCategory;
        return acc;
      }, {});

      setRateCategory(rateCategorysMap);
      setRate(rates);
      setLoading(false);
    } catch (error) {
      console.log('Error fetching room category');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRate();
  }, []);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = async () => {
    setIsModalOpen(false);
    await fetchRateCategory();
  };


  const openEditModal = (rateId) => {
    setSelectedRateId(rateId);
    setIsEditModalOpen(true);
  };

  const closeEditModal = async () => {
    setIsEditModalOpen(false);
    await fetchRateCategory();
    setSelectedRateId(null);
  };

  const handleDelete = async (rate_id) => {
    try {
      await deleteRate(rate_id);
      toast.success("Rate deleted successfully");
      await fetchRate();
    } catch (error) {
      toast.error("Failed to delete rate");
    }
  };
  return (
    <div>
      <div>
        <div className="mt-5 flex justify-between">
          <h1 className="text-2xl font-bold mt-3">
            Rate  Configuration
          </h1>
          <button
            onClick={openModal}
            type="button"
            className="text-white mt-3 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 text-center inline-flex items-center transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300 ..."
          >
            Add Rate 
          </button>
        </div>
        <CreateRate
          isOpen={isModalOpen}
          onClose={closeModal}
        // onResortCreated={fetchResorts}
        />
        <EditRate
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          selectedRateId={selectedRateId}
        />
        <div className="mt-10">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 shadow-lg">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                  Rate  Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                  Rate Code
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Rate Description
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Rate Category
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {rate?.map((rate) => (
                  <tr key={rate.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {rate.name}
                    </th>
                    <td className="px-6 py-4">{rate.code}</td>
                    <td className="px-6 py-4">{rate.description}</td>
                    <td className="px-6 py-4">{rateCategory[rate.id]}</td>
                    <td className="px-6 py-4 flex">
                      <div
                        className="font-medium cursor-pointer text-blue-600 dark:text-blue-500 hover:underline" onClick={() => openEditModal(rate.id)}
                      >
                        Edit
                      </div>
                      <div
                        className="font-medium cursor-pointer text-red-600 dark:text-red-500 hover:underline ms-3" onClick={() => handleDelete(rate.id)}
                      >
                        Remove
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Rate;
